module.exports = __webpack_public_path__ + "static/img/20019 (1).1ff5a35.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20019 (1).webp
// module id = O2Hz
// module chunks = 14